// extracted by mini-css-extract-plugin
export default {"description":"BusinessEditInfoPage_description__phh3K","container":"BusinessEditInfoPage_container__kKelO","title":"BusinessEditInfoPage_title__4dEfK"};